// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"042bb37f","358":"451260c3","455":"d423c5b7"}[chunkId] + ".chunk.js";
};